<template>
  <div class="qr-code-wrapper">
    <pay-title :order-info="orderInfo" :pay-method="payMethod"></pay-title>
    <div v-if="tradeType === 6">
      <iframe class="pay-iframe" ref="payIframe"></iframe>
    </div>
    <div v-else class="qr-code-container">
      <div class="qr-code">
        <img :src="qrSrc" />
      </div>
      <!-- 过期蒙板（仅抖音支付） -->
      <div v-if="isExpired && payMethod === 7" class="qr-expired-overlay" @click="onExpiredClick">
        <div class="expired-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
            <path d="M12 7V12L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="expired-title">支付已过期</div>
        <div class="expired-hint">点击重新获取二维码</div>
      </div>
    </div>
    <div class="method">
      <div :class="['payment-mode-icon', `method-${payMethod}`]"></div>
      <div>使用{{ payMethod === 7 ? '抖音' : payMethod === 2 ? '支付宝' : '微信' }}扫码付款</div>
    </div>

  </div>
</template>

<script>
import PayTitle from '@/components/CashierDesk/PayTitle'
import QRCode from 'qrcode'

export default {
  name: 'PayQrCode',
  components: { PayTitle },
  props: ['orderInfo', 'payMethod', 'payInfo', 'tradeType'],
  data() {
    return {
      iframeEl: null,
      qrSrc: '',
      isExpired: false,
      countdownTimer: null
    }
  },
  watch: {
    'payInfo.payData'() {
      this.initQrCode()
      this.startCountdown()
    }
  },
  mounted() {
    this.initQrCode()
    this.initIframe()
    this.startCountdown()
  },
  beforeDestroy() {
    this.stopCountdown()
  },
  methods: {
    initIframe() {
      if (!this.$refs.payIframe) return

      if (this.$refs.payIframe.contentWindow === null) {
        setTimeout(this.initIframe)
        return
      }

      const iframeDoc = this.$refs.payIframe.contentWindow.document
      iframeDoc.open().write(
        `
          <body>${this.payInfo.payData}</body>
          <script>
           document.querySelector('#alipaysubmit').submit();
         <\\/script>
          `
      )
      iframeDoc.close() // iframe onload event happens
    },
    async initQrCode() {
      if (!this.payInfo || !this.payInfo.payData) return

      const payData = this.payInfo.payData

      // 抖音支付 payData 是字符串链接，需要生成二维码
      if (this.payMethod === 7) {
        this.qrSrc = await QRCode.toDataURL(payData, {
          width: 160,
          margin: 1
        })
      } else {
        // 微信/支付宝 payData 是 base64 图片
        this.qrSrc = `data:image/png;base64,${payData}`
      }
    },
    /**
     * 启动倒计时（仅抖音支付），orderEndTime 归零时显示过期蒙板
     */
    startCountdown() {
      this.stopCountdown()

      // 仅抖音支付需要倒计时
      if (this.payMethod !== 7) return
      if (!this.payInfo || !this.payInfo.orderEndTime) return

      this.isExpired = false

      const check = () => {
        if (Date.now() >= this.payInfo.orderEndTime) {
          this.isExpired = true
          this.stopCountdown()
        }
      }

      // 立即检查一次
      check()

      if (!this.isExpired) {
        this.countdownTimer = setInterval(check, 1000)
      }
    },
    /**
     * 停止倒计时
     */
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
    /**
     * 点击过期蒙板，通知父组件重新创建支付订单
     */
    onExpiredClick() {
      this.$emit('expired')
    }
  }
}
</script>

<style lang="scss" scoped>
.qr-code-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.qr-code {
  display: inline-block;
  border: 1px solid #dedede;
  padding: 10px;
  margin: 0 auto;

  img {
    display: block;
    width: 160px;
  }
}

.qr-code-container {
  position: relative;
  display: inline-block;
}

.qr-expired-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #dedede;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
  z-index: 10;
  user-select: none;

  &:hover {
    background: rgba(255, 255, 255, 0.98);
  }
}

.expired-icon {
  color: #bfbfbf;
  width: 40px;
  height: 40px;
  margin-bottom: 8px;

  svg {
    width: 100%;
    height: 100%;
  }
}

.expired-title {
  font-size: 14px;
  color: #8c8c8c;
  font-weight: 500;
  margin-bottom: 4px;
}

.expired-hint {
  font-size: 12px;
  color: #bfbfbf;
}

.method {
  margin-top: 10px;
  font-size: 14px;
  color: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-mode-icon {
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-right: 6px;
  flex-shrink: 0;
  border-radius: 9px;
}

.method-1 {
  background-image: url('~@/assets/images/cashier-desk/wechat.png');
}
.method-5 {
  background-image: url('~@/assets/images/cashier-desk/wechat.png');
}

.method-2 {
  background-image: url('~@/assets/images/cashier-desk/alipay.png');
}

.method-6 {
  background-image: url('~@/assets/images/cashier-desk/alipay.png');
}

.method-7 {
  background-image: url('~@/assets/images/cashier-desk/douyin2.svg');
}

.pay-iframe {
  width: 162px;
  height: 166px;
  border: none;
  overflow: hidden;
  background-color: #fafafa;
}

</style>
